import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import LoginPromptToast from '../LoginPromptToast/LoginPromptToast';
import NewPortfolioModal from '../../pages/portfolios/modal/NewPortfolioModal';
import styles from './ChallengeCta.module.css';

const ChallengeCta = ({ stocks = [], optimizedWeights = {} }) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (auth.isAuthenticated) {
      setShowModal(true);
    } else {
      toast.error(
        <LoginPromptToast 
          signInRedirect={auth.signinRedirect} 
          navigate={navigate} 
        />
      );
    }
  };

  const handleCreated = (id) => {
    setShowModal(false);
    navigate(`/portfolios/${id}`);
  };

  // 초기 홀딩 데이터 변환 로직도 공통화
  const initialHoldings = stocks.map(ticker => ({
    ticker,
    weight: (parseFloat(optimizedWeights[ticker]) || 0) / 100
  }));

  return (
    <>
      <div className={styles.buttonWrapper}>
        <button className={styles.createPortButton} onClick={handleClick}>
          <span className={styles.icon}>🏆</span>
          <span>{t("backtest.challengeTopOnePercent")}</span>
        </button>
      </div>

      {showModal && auth.isAuthenticated && (
        <NewPortfolioModal 
          onClose={() => setShowModal(false)} 
          onCreated={handleCreated} 
          initialHoldings={initialHoldings} 
        />
      )}
    </>
  );
};

export default ChallengeCta;